'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../enums/accordion.js');
require('../enums/alert.js');
require('../enums/avatar.js');
require('../enums/breakpoints.js');
require('../enums/button.js');
require('../enums/code-editor.js');
var colors = require('../enums/colors.js');
require('../enums/combobox.js');
require('../enums/date.js');
require('../enums/drag-and-drop.js');
require('../enums/dialog.js');
require('../enums/divider.js');
require('../enums/dropdown.js');
require('../enums/fieldset.js');
require('../enums/font-icon.js');
require('../enums/fonts.js');
require('../enums/headings.js');
require('../enums/input.js');
require('../enums/keys.js');
require('../enums/list.js');
require('../enums/listbox.js');
require('../enums/loader.js');
require('../enums/margin.js');
require('../enums/option.js');
require('../enums/pill.js');
require('../enums/placements.js');
require('../enums/popout.js');
require('../enums/privacy.js');
require('../enums/radio-group.js');
require('../enums/status.js');
require('../enums/switch.js');
require('../enums/table.js');
require('../enums/tooltip.js');
require('../enums/transitions.js');
require('../enums/widths.js');

const defaultFieldsetDark = {
    backgroundColor: colors.BrandfolderHexColors.Text,
    borderColor: colors.BrandfolderHexColors.Text,
    textColor: colors.BrandfolderHexColors.White
};
const defaultFieldsetLight = {
    backgroundColor: colors.BrandfolderHexColors.DirtyMarshmallowHalf,
    borderColor: colors.BrandfolderHexColors.DirtyMarshmallowHalf,
    textColor: colors.BrandfolderHexColors.Text
};

exports.defaultFieldsetDark = defaultFieldsetDark;
exports.defaultFieldsetLight = defaultFieldsetLight;
//# sourceMappingURL=fieldset.js.map
